import NUIAlert from '@/components/Alert/Alert'
import { IConfigSeller } from '@/models/configSeller'
import { IAppStore } from '@/models/store.model'
import { webApiService } from '@/services'
import { blobToBase64 } from '@/utils/blobToBase64.util'
import { Button, cn, Switch } from '@nextui-org/react'
import { fromImage } from 'imtool'
import { enqueueSnackbar } from 'notistack'
import React, { useCallback, useEffect, useState } from 'react'
import { Accept, useDropzone } from 'react-dropzone'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { useTradeinContext } from '../hooks/useTradeinContext'

const OsiptelEvaluation = () => {
  console.log('osiptel component')
  const { ctx, saveCtx } = useTradeinContext()
  const userState = useSelector((store: IAppStore) => store.user)
  const [bloqued, setBloqued] = useState<boolean>(false)
  const [data, setData] = useState<{ loading: boolean, imagen: string }>({ loading: false, imagen: '' })
  const { slug, id } = useParams()
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isSamsungPeru = configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe'

  const onDrop = useCallback((acceptedFiles: File[]) => {
    const validFiles = acceptedFiles.filter(file =>
      ['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)
    )
    console.log('🚀 ~ onDrop ~ validFiles:', validFiles)

    // Asegúrate de que 'files' es de tipo 'File[]'
    saveCtx({
      ...ctx,
      files: [...validFiles]
    })
  }, [ctx, saveCtx])

  const accept: Accept = {
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg']
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept,
    maxFiles: 1
  })

  const removeFile = (file: File, event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    saveCtx({
      ...ctx,
      files: ctx.files.filter(f => f !== file)
    })
  }

  const uploadImage = async () => {
    for (const element of ctx.files) {
      if (element.nameFile === undefined) {
        console.log('entro', ctx)
        delete element.preview
        element.blob = await fromImage(element).then((tool: any) => tool.thumbnail(800, false).toBlob())
        element.base64 = await blobToBase64(element.blob)
        delete element.blob
      }
    }
    console.log('🚀 ~ forawait ~ ctx.files:', ctx.files)
    setData({ ...data, loading: true })

    webApiService.saveFiles({ id, store_user: String(userState.id), files: ctx.files, seller: slug, osiptel: true, osiptelBlocked: bloqued }).then(() => {
      enqueueSnackbar(ctx.files.length > 0 ? 'Imagen cargada con exito' : 'Información cargada con exito', { variant: 'success' })
      saveCtx({ ...ctx, files: [], reload: true })
      setData({ ...data, loading: false })
    }).catch((error) => {
      enqueueSnackbar(error.message, { variant: 'error' })
      console.log('error ==>', error)
      setData({ ...data, loading: false })
    })
  }

  const loadData = () => {
    setData({ ...data, loading: true })
    webApiService.getFiles(String(id)).then((res: any) => {
      setData({ loading: false, imagen: res.data.find((item: any) => item.name.includes('osiptel'))?.name ?? null })
    }).catch((error) => {
      enqueueSnackbar(error.message, { variant: 'error' })
      console.log('error ==>', error)
      setData({ ...data, loading: false })
    })
  }

  useEffect(() => {
    if (ctx.tradein.osiptel_evaluation !== null) loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx.tradein.osiptel_evaluation])

  return (
    <div className='bg-white rounded-lg shadow-lg p-4 h-full'>
      <div className='h-full'>
        <div className='grid grid-cols-2 border-b-1 mb-2 '>
          <div><h6 className=' font-bold text-xl pb-2'>Evaluación OSIPTEL</h6></div>
        </div>
        {
      }
        <span />
        {
        ctx.tradein.osiptel_evaluation === null
          ? (
            <div className='py-2'>
              <Switch
                isSelected={bloqued} onValueChange={(value) => setBloqued(value)}
                classNames={{
                  base: cn(
                    'inline-flex flex-row-reverse w-full max-w-full bg-content1 hover:bg-content2 items-center',
                    'justify-between cursor-pointer rounded-lg gap-2 p-4 border-2 border-transparent',
                    'data-[selected=true]:border-primary'
                  ),
                  wrapper: 'p-0 h-4 overflow-visible',
                  thumb: cn('w-6 h-6 border-2 shadow-lg',
                    'group-data-[hover=true]:border-primary',
                    // selected
                    'group-data-[selected=true]:ml-6',
                    // pressed
                    'group-data-[pressed=true]:w-7',
                    'group-data-[selected]:group-data-[pressed]:ml-4'
                  )
                }}
              >
                <div className='flex flex-col gap-1'>
                  <p className='text-medium'>¿El dispositivo tiene bloqueo?</p>
                </div>
              </Switch>
              <div className='pt-2'>
                <NUIAlert type='info'>Para avanzar debe subir foto de la evidencia</NUIAlert>
                <div
                  {...getRootProps()} style={{
                    border: ctx.files.length > 0 ? '1px solid #ccc' : '1px dashed #ff8181',
                    borderRadius: '5px',
                    padding: '20px',
                    textAlign: 'center',
                    marginTop: '6px',
                    cursor: 'pointer',
                    backgroundColor: isDragActive ? '#cce5ff' : ctx.files.length > 0 ? '#fff' : '#ffefef',
                    color: isDragActive ? '#ffffff' : '#000000'
                  }}
                >
                  <input {...getInputProps()} />
                  {
                isDragActive
                  ? (
                    <p>Arrastra y suelta las imágenes aquí...</p>
                    )
                  : (
                    <div hidden={ctx.files.length > 0}>
                      <h4 className='font-extrabold'>Adjuntar imagen (Requerido)</h4>
                      <p>Arrastra y suelta la imagen aquí, o haz clic para seleccionar archivos</p>
                    </div>
                    )
              }
                  <p color='textSecondary' hidden={ctx.files.length > 0}>
                    (Solo se permiten archivos .png, .jpg y .jpeg)
                  </p>
                  <div className='grid grid-cols-1'>
                    {ctx.files.map((file, index) => (
                      <div key={index} className='max-w-44'>
                        <img src={URL.createObjectURL(file)} alt={`preview ${index}`} />
                        <p>{file.name}</p>
                        <Button color='danger' size='sm' onClick={(event: any) => removeFile(file, event)}>
                          Eliminar
                        </Button>
                      </div>
                    ))}
                  </div>

                </div>
              </div>
            </div>
            )
          : null
      }

        {
        // Si no se ha cargado el detalle de los descuentos, no se muestra el boton
        ctx.tradein.osiptel_evaluation === null
          ? (
            <div className='mt-2'>
              <Button isLoading={data.loading} isDisabled={ctx.files.length === 0 && ctx.tradein.sbu !== 'Smartwatch'} color='primary' onClick={uploadImage}>
                {ctx.tradein.sbu === 'Smartwatch' ? 'Enviar' : 'Cargar imagen'}
              </Button>
            </div>
            )
          : null
      }
        {
        ctx.tradein.osiptel_evaluation !== null && data.imagen !== null
          ? (
            <div className='p-4 bg-slate-100 border-1 border-slate-500 rounded-lg'>
              <p className='text-large pb-4 font-bold'> {ctx.tradein.osiptel_evaluation === 1 ? 'El dispositivo tiene bloqueo' : 'El dispositivo no tiene bloqueo'} </p>
              <img
                className={isSamsungPeru ? 'h-[400px]' : 'w-full'}
                src={`https://${import.meta.env.VITE_BUCKET}.s3.us-west-2.amazonaws.com/${configSeller.config.s3.FOLDER_APP}/imagenes/${id}/${data.imagen}`} alt={ctx.tradein.osiptel_evaluation === 1 ? 'Mayor ó igual al 80%' : 'No supera el 80%'}
              />
            </div>
            )
          : null
      }

      </div>
    </div>
  )
}

export default OsiptelEvaluation
